export default class {
  constructor() {
    if(!document.getElementById('header')) {
      return; // Ajax
    }

    this.offsetHeader = document.getElementById('header').offsetHeight + 32;
    this.links = this.getLinks();
    this.scrollTo();
  }

  // Return all links which has # in the url
  getLinks() {
    const callback = el => el.getAttribute('href') && el.getAttribute('href').indexOf('#') !== -1;
    const el = Array.from(document.getElementsByTagName('a'));
    return el.filter(callback);
  }

  // Action
  scrollTo() {
    let self = this;
    [...this.links].forEach((item) => {

      // Onclick start
      item.onclick = function (e) {
        e.preventDefault();

        const element = document.getElementById(item.getAttribute('href').substring(1));
        if (!element) {
          // Probably an external link
          window.location.href = this.getAttribute('href');
          return;
        }

        // Scroll to the element
        window.scrollBy({
          top: element.getBoundingClientRect().y - self.offsetHeader,
          left: 0,
          behavior: 'smooth'
        });
      }
    });
  }
}
